<nz-layout class="content-section">
  <nz-content>
    <div class="vsconsensus-page-container">
      <div class="filters">
        <div class="select-container">
          <label class="select-label">Filter by Percent Diff</label>
          <nz-select
            class="border-black"
            [(ngModel)]="gridFilters.vsConsensus"
            [nzSize]="'small'"
            [nzDropdownClassName]="'filter-select-dropdown'"
            style="width: 150px;"
            (ngModelChange)="vsconsensusGrid.onFilterChange(['percentChange'])"
          >
            <nz-option [nzLabel]="'Show All'" [nzValue]="'default'"></nz-option>
            <nz-option [nzLabel]="'More than 2%'" [nzValue]="'2'"></nz-option>
            <nz-option [nzLabel]="'More than 5%'" [nzValue]="'5'"></nz-option>
            <nz-option [nzLabel]="'More than 10%'" [nzValue]="'10'"></nz-option>
          </nz-select>
        </div>
        <div class="select-container">
          <label class="select-label">Filter</label>
          <nz-input-group
            class="border-black"
            [nzSuffix]="clearSuffixTemplate"
            [nzSize]="'small'"
            style="width:160px; padding: 0 5px;"
          >
            <input
              [(ngModel)]="gridFilters.filterLineItem"
              nz-input
              placeholder="Search"
              (keyup)="vsconsensusGrid.onFilterChange(['lineitem'])"
            />
          </nz-input-group>
          <ng-template #clearSuffixTemplate
            ><i
              nz-icon
              nz-tooltip
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="gridFilters.filterLineItem"
              (click)="onClearLineitemSearch(vsconsensusGrid)"
            ></i
          ></ng-template>
        </div>

        <div class="yoy-switches">
          <div class="clear-filter" (click)="onClearClick()" *ngIf="showClear">
            Clear
          </div>
          <div class="show-yoy">
            Show YoY%
            <nz-switch
              nzSize="small"
              [ngModel]="gridFilters.showYoY"
              (ngModelChange)="onFilterChange($event, 'showYoY')"
            ></nz-switch>
          </div>
        </div>
      </div>
      <app-vsconsensus-grid
        #vsconsensusGrid
        [vsconsensusMeta]="vsconsensusMeta"
        [gridFilters]="gridFilters"
        (showClearFilter)="showClearFilter($event)"
      ></app-vsconsensus-grid>
    </div>
  </nz-content>
</nz-layout>
